import { render, staticRenderFns } from "./CwvThresholdChanges.vue?vue&type=template&id=0a0f5d0c&scoped=true&"
import script from "./CwvThresholdChanges.vue?vue&type=script&lang=js&"
export * from "./CwvThresholdChanges.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a0f5d0c",
  null
  
)

export default component.exports